import { FC } from "react";

import { MenuOutlined } from "@ant-design/icons";
import { Layout, Button } from "antd";

import UserProfile from "./UserProfile";
import useDeviceType from "../../../utils/deviceType";
import DynamicBreadcrumb from "../../breadcrumb/Breadcrumb";
import { useSidebar } from "../sidebar/Sidebar";

// import LanguageSelector from "./LanguageSelector";

const { Header } = Layout;

const styles: Record<string, React.CSSProperties> = {
  header: {
    width: "100%",
    borderBottom: "2px solid #DBDBDB",
    padding: "15px 25px",
    height: "auto",
  },
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "100%",
  },
  containerDetail: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "auto",
    gap: "20px",
  },
  leftSection: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
};

const DashboardHeader: FC = () => {
  const { setCollapsed } = useSidebar();
  const { isMobile } = useDeviceType();

  const handleOpenSidebar = () => {
    setCollapsed(false);
  };

  return (
    <Header style={styles.header}>
      <div style={styles.container}>
        <div style={styles.leftSection}>
          {isMobile && (
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={handleOpenSidebar}
            />
          )}
          <DynamicBreadcrumb />
        </div>
        <div style={styles.containerDetail}>
          {/* <LanguageSelector /> */}
          <UserProfile />
        </div>
      </div>
    </Header>
  );
};

export default DashboardHeader;
